"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const actions_1 = require("../../../../actions");
const reducers_1 = require("../../../../reducers");
const PopoverModalForm_1 = require("../../components/PopoverModalForm");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const EventConditionSelection = ({ closePopoverModalForm, device, eventName, predicate, removeEventTriggerFilter, updateActivePopover, updateEventAttributeOperator, }) => {
    const operator = predicate ? predicate.booleanOperator : null;
    const getEventConditionDisplayName = () => {
        switch (operator) {
            case 'OR':
                return (React.createElement("div", null,
                    React.createElement(src_1.Text, { text: "ANY", size: "large", textStyle: Object.assign(Object.assign({}, src_1.semibold), { color: src_1.charcoal, marginRight: 5 }) }),
                    React.createElement(src_1.Text, { text: "of the following conditions", size: "large", textStyle: { color: src_1.charcoal } })));
            case 'AND':
                return (React.createElement("div", null,
                    React.createElement(src_1.Text, { text: "ALL", size: "large", textStyle: Object.assign(Object.assign({}, src_1.semibold), { color: src_1.charcoal, marginRight: 5 }) }),
                    React.createElement(src_1.Text, { text: "of the following conditions", size: "large", textStyle: { color: src_1.charcoal } })));
            default:
                return null;
        }
    };
    const getPopoverFormInputProps = () => {
        if (operator !== null) {
            return {
                id: 'automated-event-condition-selection',
                label: 'If matching...',
                media: device,
                fieldStyle: {
                    marginTop: 0,
                    padding: device === 'Desktop' ? '24px 0 23px' : 0,
                    minHeight: 'none',
                    width: '100%',
                },
                isEditingText: false,
                customSecondaryText: getEventConditionDisplayName(),
                text: getEventConditionDisplayName() ? ' ' : getEventConditionDisplayName(),
            };
        }
        else {
            return {
                id: 'automated-event-condition-selection',
                label: ' ',
                media: device,
                fieldStyle: {
                    marginTop: 0,
                    padding: device === 'Desktop' ? '24px 0 23px' : 0,
                    minHeight: 'none',
                    width: '100%',
                },
                isEditingText: false,
                text: '',
                customPrimaryText: React.createElement(src_1.Text, { text: "No conditions", label: true, size: "large" }),
            };
        }
    };
    const getPopoverNavbarProps = (handleClosePopoverModal) => ({
        buttonLeftCallback: () => {
            handleClosePopoverModal();
        },
    });
    const getPopoverModalProps = (handleClosePopoverModal) => ({
        placement: 'left',
        navBarProperties: Object.assign({ buttonLeft: 'Cancel', id: 'navBarId', style: {
                containerStyle: {
                    borderRadius: '3px 3px 0px 0px',
                },
            } }, getPopoverNavbarProps(handleClosePopoverModal)),
    });
    const getAddButton = () => {
        switch (device) {
            case 'Desktop':
                return (React.createElement("div", { key: "event-condition-selection-add" },
                    React.createElement(src_1.Button, { text: "Change", type: "regular", style: {
                            innerStyle: {
                                fontSize: 17,
                            },
                            outerStyle: {
                                height: null,
                                lineHeight: '24px',
                            },
                        }, mouseDownColors: {
                            active: src_1.turquoise,
                            inactive: src_1.aquamarine,
                        } })));
            case 'Tablet':
                return React.createElement(src_1.ChangeIcon, { key: "event-selection-add", fill: src_1.titanium });
            default:
                return null;
        }
    };
    const getEditButton = () => {
        switch (device) {
            case 'Desktop':
                return (React.createElement(src_1.Button, { text: "Change", type: "regular", style: {
                        innerStyle: {
                            fontSize: 17,
                        },
                    }, mouseDownColors: {
                        active: src_1.turquoise,
                        inactive: src_1.aquamarine,
                    }, key: "event-selection-change" }));
            case 'Tablet':
                return React.createElement(src_1.ChangeIcon, { key: "event-selection-change", fill: src_1.titanium });
            default:
                return null;
        }
    };
    const closePopoverModal = () => {
        closePopoverModalForm();
        setTimeout(() => updateActivePopover(''), device === 'Mobile' ? 500 : 0);
    };
    return (eventName.length > 0 && (React.createElement(PopoverModalForm_1.default, { popoverFormInputProps: getPopoverFormInputProps(), presentationType: device !== 'Mobile' ? 'popover' : 'modal', field: "automated-event-condition-selection", popoverModalProps: getPopoverModalProps, popoverNavbarProps: getPopoverNavbarProps, addButton: getAddButton(), editButton: getEditButton() },
        React.createElement("div", { style: {
                width: device === 'Mobile' ? '100%' : 384,
            } },
            device === 'Mobile' && (React.createElement(src_1.Text, { size: "h1", text: "If matching...", textStyle: { margin: '24px 24px 8px 24px' } })),
            React.createElement(src_1.SelectableList, { device: device },
                React.createElement("div", { key: "selectable-event-condition-selection-or", onClick: (e) => {
                        e.stopPropagation();
                        updateEventAttributeOperator('OR');
                        closePopoverModal();
                    }, style: {
                        display: 'flex',
                        height: device !== 'Mobile' ? 55 : 71,
                        width: '100%',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    } },
                    React.createElement("div", null,
                        React.createElement(src_1.Text, { text: "ANY", size: device === 'Mobile' ? 'large' : 'medium', textStyle: Object.assign(Object.assign({}, src_1.semibold), { color: src_1.charcoal, marginRight: 5 }) }),
                        React.createElement(src_1.Text, { text: "of the following conditions", size: device === 'Mobile' ? 'large' : 'medium', textStyle: { color: src_1.charcoal } })),
                    React.createElement(src_1.RadioButton, { selected: operator === 'OR', style: {
                            outerStyle: { height: 18, width: 18 },
                        } })),
                React.createElement("div", { key: "selectable-event-condition-selection-and", onClick: (e) => {
                        e.stopPropagation();
                        updateEventAttributeOperator('AND');
                        closePopoverModal();
                    }, style: {
                        display: 'flex',
                        height: device !== 'Mobile' ? 55 : 71,
                        width: '100%',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    } },
                    React.createElement("div", null,
                        React.createElement(src_1.Text, { text: "ALL", size: device === 'Mobile' ? 'large' : 'medium', textStyle: Object.assign(Object.assign({}, src_1.semibold), { color: src_1.charcoal, marginRight: 5 }) }),
                        React.createElement(src_1.Text, { text: "of the following conditions", size: device === 'Mobile' ? 'large' : 'medium', textStyle: { color: src_1.charcoal } })),
                    React.createElement(src_1.RadioButton, { selected: operator === 'AND', style: {
                            outerStyle: { height: 18, width: 18 },
                        } })),
                React.createElement("div", { key: "selectable-event-condition-selection-no-condition", onClick: (e) => {
                        e.stopPropagation();
                        removeEventTriggerFilter();
                        closePopoverModal();
                    }, style: {
                        display: 'flex',
                        height: device !== 'Mobile' ? 55 : 71,
                        width: '100%',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    } },
                    React.createElement(src_1.Text, { text: "No conditions", size: device === 'Mobile' ? 'large' : 'medium' }),
                    React.createElement(src_1.RadioButton, { selected: operator === null, style: {
                            outerStyle: { height: 18, width: 18 },
                        } })))))));
};
const mapStateToProps = (state) => ({
    eventName: reducers_1.getEditableCampaignEventTrigger(state).eventName,
    predicate: reducers_1.getEditableEventAttributesEventTriggerFilter(state),
});
const mapDispatchToProps = (dispatch) => {
    return {
        removeEventTriggerFilter: () => dispatch(actions_1.removeEventTriggerFilter('EventAttributesEventTriggerFilter')),
        updateEventAttributeOperator: (operator) => {
            dispatch(actions_1.updateEventAttributeOperator(operator));
        },
        updateEventAttributePredicates: (predicates) => dispatch(actions_1.updateEventAttributePredicates(predicates)),
        updateActivePopover: (field) => dispatch(actions_1.updateActivePopover(field)),
        closePopoverModalForm: () => dispatch(actions_1.closePopoverModalForm()),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(EventConditionSelection);
